exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-container[data-v-a44f71e2]{max-height:55px;min-height:55px;margin-bottom:5px;overflow:hidden}", ""]);

// exports
